import { useRouter } from "next/router"
import React from "react"
import Button from "src/components/tailwind-components/Button"
import { PartnerPreRegistrationSummary } from "../types"
import { dayjs } from "src/lib/dayjs"

interface PartnerPreRegistrationTableRowProps {
  partnerPreRegistration: PartnerPreRegistrationSummary
  onRevokeClick: () => void
  onReviveClick: () => void
}

export const PartnerPreRegistrationTableRow: React.FC<PartnerPreRegistrationTableRowProps> = ({
  partnerPreRegistration,
  onRevokeClick,
  onReviveClick,
}) => {
  const router = useRouter()

  const statusLabel = {
    in_review: "審査待ち",
    in_compliance_review: "コンプラ確認",
    approved: "審査通過",
    rejected: "否認",
    revoked: "取り下げ",
    checking: "確認中",
  }

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    // 編集ページへ遷移
    router.push(`/admin/partner-pre-registrations/${partnerPreRegistration.id}`)
  }

  const handleRevokeClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    const confirmed = window.confirm("取り下げますか？")
    if (confirmed) {
      onRevokeClick()
    }
  }

  const handleReviveClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    const confirmed = window.confirm("取り下げを解除しますか？")
    if (confirmed) {
      onReviveClick()
    }
  }

  // 日付フォーマット（日本語曜日を含む）
  const formatDate = (dateString: string) => {
    return dayjs(dateString).format("YYYY/MM/DD (ddd)")
  }

  return (
    <tr className="cursor-pointer border-b border-gray-200 transition-colors hover:bg-gray-50">
      {/* ID */}
      <td className="px-4 py-3 text-center align-middle text-[14px] font-bold text-gray-900">
        <a
          href={`/admin/partner-pre-registrations/${partnerPreRegistration.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline inline-block"
        >
          {partnerPreRegistration.id}
        </a>
      </td>

      {/* 会社名 */}
      <td className="px-4 py-3 align-middle text-[14px] font-bold text-gray-900">
        <a
          href={`/admin/partner-pre-registrations/${partnerPreRegistration.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline inline-block"
        >
          {partnerPreRegistration.companyName}
        </a>
      </td>
      {/* ステータス */}
      <td className="px-4 py-3 text-center align-middle text-[14px] font-bold text-gray-900">
        {statusLabel[partnerPreRegistration.status]}
      </td>

      {/* 申込日 */}
      <td className="px-4 py-3 text-center align-middle text-[14px] font-bold text-gray-900">
        {formatDate(partnerPreRegistration.createdAt)}
      </td>

      <td className="flex gap-8 px-4 py-3 text-right align-middle">
        <Button
          type="button"
          mode="primary"
          label="編集"
          className="min-w-[6.4rem]"
          onClick={handleEditClick}
          disabled={false}
        />
        {(partnerPreRegistration.status == "in_review" ||
          partnerPreRegistration.status == "in_compliance_review" ||
          partnerPreRegistration.status == "checking") && (
          <Button
            type="button"
            mode="secondary"
            label="取り下げ"
            className="min-w-[8.0rem]"
            onClick={handleRevokeClick}
            disabled={false}
          />
        )}
        {partnerPreRegistration.status == "revoked" && (
          <Button
            type="button"
            mode="success"
            label="復活"
            className="min-w-[8.0rem]"
            onClick={handleReviveClick}
            disabled={false}
          />
        )}
      </td>
    </tr>
  )
}
